import React, { useContext } from 'react';
import { EventDetailsContext } from '../../context/event_details.context';
import format from 'date-fns/format';
import { DATE_FORMAT, DATE_FORMAT_NO_YEAR } from '../../constants/event_details.constants';

const StartDate: React.FC = () => {
  const { event } = useContext(EventDetailsContext);
  if (!event?.starts_at) return null;
  return (
    <span data-testid='formatted-start-date'>
      {format(
        new Date(event?.starts_at),
        event?.multiYearEvent
          ? DATE_FORMAT
          : event?.multiDayEvent
            ? DATE_FORMAT_NO_YEAR
            : DATE_FORMAT
      )}
    </span>
  );
};

export default StartDate;
